import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Page from 'components/util/page-component';
import Tooltip from 'components/common/tool-tip-component';
import { ROUTE_CONSTANTS, parseRoute } from 'constants/util/route-constants';
import { ReactComponent as BackButton } from 'icons/back-button.svg';
import Button, { BUTTON_TYPES } from 'components/common/button-component';
import { ReactComponent as InfoIcon } from 'icons/bulb.svg';
import { ReactComponent as SwapIcon } from 'icons/swap.svg';
import LeftSideView from './report-preview-left-side-view';
import RightSideView from './report-preview-right-side-view';
import { clearReportPreviewPageData } from 'store/actions/report-preview-page-actions';
import { clearStatementPageStore } from 'store/actions/statement-content-actions';
import { clearSelectedStatement } from 'store/actions/selected-statement-actions';

export const REPORT_PREVIEW_BLOCK = 'report-preview-page';
export const REPORT_PREVIEW_BLOCK_ID = 'report-preview-page-id';
const ICON_SIZE = 25;

const Header = () => {
  const { projectId, readOnly, revisionId, statementId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onBackButtonClick = async () => {
    await dispatch(clearReportPreviewPageData());
    navigate(
      parseRoute(ROUTE_CONSTANTS.STATEMENT_CONTENT_PAGE, {
        params: {
          projectId,
          statementId,
          revisionId,
          readOnly,
        },
      }),
    );
  };
  return (
    <div className={`${REPORT_PREVIEW_BLOCK}__header`}>
      <div className={`${REPORT_PREVIEW_BLOCK}__header-container`}>
        <Button.IconButton
          id={`${REPORT_PREVIEW_BLOCK_ID}__header-back-button`}
          className={`${REPORT_PREVIEW_BLOCK}__header-back-button`}
          type={BUTTON_TYPES.icon}
          Icon={BackButton}
          onClick={onBackButtonClick}
        />
        <div className={`${REPORT_PREVIEW_BLOCK}__header-title`}>
          <FormattedMessage
            id={'statement.navigation.report.preview.header.title'}
          />
        </div>
        <Tooltip
          text="statement.navigation.report.preview.header.tooltip.info"
          id={`${REPORT_PREVIEW_BLOCK}-info-tooltip`}
        >
          <InfoIcon id="info-icon" width={ICON_SIZE} height={ICON_SIZE} />
        </Tooltip>
      </div>
    </div>
  );
};

const ReportPreview = (props) => {
  const dispatch = useDispatch();
  const [toggleViews, setToggleViews] = useState(false);

  const handleToggle = () => {
    setToggleViews(!toggleViews);
  };

  useEffect(() => {
    return () => {
      dispatch(clearStatementPageStore());
      dispatch(clearSelectedStatement());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page className={REPORT_PREVIEW_BLOCK}>
      <Header />
      <div
        className={classNames({
          [`${REPORT_PREVIEW_BLOCK}__body-section`]: true,
          [`${REPORT_PREVIEW_BLOCK}__body-section--reverse`]: toggleViews,
        })}
      >
        <div
          className={`${REPORT_PREVIEW_BLOCK}__swap-icon`}
          onClick={handleToggle}
        >
          <SwapIcon width={ICON_SIZE} height={ICON_SIZE} />
        </div>
        <div className={`${REPORT_PREVIEW_BLOCK}__body-section--left`}>
          <LeftSideView toggleViews={toggleViews} />
        </div>
        <div className={`${REPORT_PREVIEW_BLOCK}__body-section--right`}>
          <RightSideView toggleViews={toggleViews} />
        </div>
      </div>
    </Page>
  );
};

export default ReportPreview;
